import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();
  const token = localStorage.getItem('token');

  useEffect(() => {
    const path = `${location.pathname}${location.search || ''}`;
    if (path.startsWith('/admin/') && path !== '/admin/login') {
      localStorage.setItem('adminLastPath', path);
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const verifyAuth = async () => {
      if (!token) {
        console.log('❌ Pas de token trouvé');
        setIsAuthenticated(false);
        return;
      }

      try {
        console.log('🔍 Vérification du token...');
        // Utiliser l'URL complète du backend ou le proxy Netlify
        const response = await axios.get(`${API_BASE_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        console.log('✅ Réponse auth:', response.data);

        if (response.data.user && response.data.user.role === 'admin') {
          setIsAuthenticated(true);
          setIsAdmin(true);
          localStorage.setItem('user', JSON.stringify(response.data.user));
          console.log('✅ Utilisateur admin authentifié');
        } else {
          console.log('❌ Utilisateur non admin');
          setIsAuthenticated(false);
          setIsAdmin(false);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } catch (error) {
        console.error('❌ Erreur vérification auth:', error);
        console.error('Détails:', error.response?.data);
        setIsAuthenticated(false);
        setIsAdmin(false);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    };

    verifyAuth();
  }, [token]);

  // Afficher un loader pendant la vérification
  if (isAuthenticated === null) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0505 100%)',
        color: 'white',
        fontSize: '1.5rem'
      }}>
        🔄 Vérification...
      </div>
    );
  }

  // Rediriger vers la page de connexion si non authentifié ou non admin
  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/admin/login" replace state={{ from: `${location.pathname}${location.search || ''}` }} />;
  }

  return children;
};

export default ProtectedRoute;
